import { render, staticRenderFns } from "./ChatInputArea.vue?vue&type=template&id=c612c580&scoped=true"
import script from "./ChatInputArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatInputArea.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChatInputArea.vue?vue&type=style&index=0&id=c612c580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c612c580",
  null
  
)

export default component.exports